"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSubscriptionTemplate = void 0;
const lit_html_1 = require("lit-html");
const control_1 = require("../form/control");
/**
 * Возвращает шаблон основного домена в списке
 */
function getSubscriptionTemplate(subscriptionService, translations, successCallback) {
    const form = new control_1.Form({
        email: new control_1.TextControl(''),
    });
    const subscribe = () => __awaiter(this, void 0, void 0, function* () {
        var _a;
        try {
            yield subscriptionService.subscribe({
                SWEBSITE: window.location.host,
                EMAIL: (_a = form.get('email')) === null || _a === void 0 ? void 0 : _a.getValue(),
            });
            successCallback();
        }
        catch (err) {
            if (err.errors) {
                form.setErrors(err.errors);
            }
            else if (err.error) {
                form.setErrors({ email: err.error });
            }
        }
    });
    return (0, lit_html_1.html) `
        <div class="d-flex gap-2">
            <art-text-field .control="${form.get('email')}" placeholder="${translations.instant('email')}" style="flex: 1;" @enter="${subscribe}"></art-text-field>
            <button class="btn btn-secondary" @click="${subscribe}">${translations.instant('subscribe')}</button>
        </div>
    `;
}
exports.getSubscriptionTemplate = getSubscriptionTemplate;
